import React, { useEffect, useState } from "react";
import { number, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./poll-card.m.css";

const PollCard = ({ polltypeId, index, lang, pollTypeHostUrl }) => {
  const [pollData, setPollData] = useState(null);

  useEffect(() => {
    getPollData();
  }, []);

  const getPollData = async () => {
    const response = await fetch(`${pollTypeHostUrl}/p/api/polls/${polltypeId}`);
    const result = await response.json();
    setPollData(result.poll);
  };

  if (!pollData) {
    return null;
  }

  const { topic, "total-votes": totalVotes, opinions } = pollData;

  return (
    <div styleName={`base ${lang}-wrapper`}>
      <div styleName="poll-number">{`Poll ${index + 1}`}</div>
      {topic && <div styleName="poll-description">{topic}</div>}
      <div styleName="key-value-wrapper">
        <span styleName="key">Total votes: </span>
        {totalVotes}
      </div>
      {opinions &&
        opinions.length > 0 &&
        opinions.map((item, index) => {
          const individualCount = Math.round((totalVotes * item["percentage-votes"]) / 100);

          return (
            <div styleName="key-value-wrapper" key={index}>
              <span styleName="key">{`${item.text}: `}</span>
              {`${individualCount} (${item["percentage-votes"]}%)`}
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  pollTypeHostUrl: get(state, ["qt", "config", "publisher-attributes", "pollTypeHostUrl"], null),
});

PollCard.propTypes = {
  polltypeId: number,
  index: number,
  lang: string,
  pollTypeHostUrl: string,
};

export default connect(mapStateToProps)(PollCard);
